import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';

export const SUPPORTED_LANGUAGES = ['it', 'en', 'es', 'fr', 'ar'];
export const RTL_LANGUAGES = new Set(['ar']);
export const DEFAULT_LANGUAGE = 'it';

// Map locale to Intl locale + currency (as chosen by user: currency changes with language)
export const LOCALE_CONFIG = {
  it: { intlLocale: 'it-IT', currency: 'EUR' },
  en: { intlLocale: 'en-US', currency: 'USD' },
  es: { intlLocale: 'es-ES', currency: 'EUR' },
  fr: { intlLocale: 'fr-FR', currency: 'EUR' },
  ar: { intlLocale: 'ar-SA', currency: 'SAR' },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      ar: { translation: ar },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: true, // 'en-US' -> 'en', 'fr-CA' -> 'fr'
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'hc_lang',
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

// Sync <html lang> AND <html dir> whenever the language changes
const applyHtmlLang = (lng) => {
  const short = (lng || DEFAULT_LANGUAGE).split('-')[0];
  document.documentElement.lang = short;
  document.documentElement.dir = RTL_LANGUAGES.has(short) ? 'rtl' : 'ltr';
};

applyHtmlLang(i18n.language);
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
